
import 'aos/dist/aos.css'
import { computed, defineComponent, ref, watch } from 'vue'
import { useStore } from '@/store'
import RenderingRandselBag from '@/components/Rendering/RenderingRandselBag.vue'
import positionSettings from '@/settings/position-settings.json'
import { RenderingActionTypes } from '@/store/modules/rendering/action-types'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingFullorder',
  components: {
    RenderingRandselBag
  },
  setup() {
    const store = useStore()
    const currentTab = computed(() => store.getters.currentTab)
    const cameraPos = computed(() => store.getters.cameraPos)
    let oldCameraPos = 0
    let direction = ref('left')

    // prettier-ignore
    watch(() => currentTab.value, (tab) => {
        const camPos = positionSettings.cameraPositionsFullorder[tab].renderingCamera
        store.dispatch(RenderingActionTypes.SET_CAMERA_POS, camPos)
      }
    )

    // prettier-ignore
    watch(() => cameraPos.value, (camPos) => {
        direction.value = determineDirection(camPos)
        oldCameraPos = camPos
      }
    )

    function determineDirection(newCameraPos: number): string {

      if (newCameraPos == 0) {
        if (oldCameraPos == 1) {
          return 'right'
        } else {
          return 'left'
        }
      } else if (newCameraPos == 1) {
        if (oldCameraPos == 2) {
          return 'right'
        } else {
          return 'left'
        }
      } else if (newCameraPos == 2) {
        if (oldCameraPos == 0) {
          return 'right'
        } else {
          return 'left'
        }
      } else {
        // should not happen
        SentrySingleton.instance.captureMessage('determineDirection unkown camera pos ' + newCameraPos)
        return 'left'
      }
    }

    return {
      currentTab,
      cameraPos,
      direction
    }
  }
})
